<template>
  <ContactForm :open="openContactForm" @hide-modal="hideContactForm()" />
  <ContextMenu @update:open="isOpen = $event">
    <ContextMenuButtonTrigger>
      <button type="button" class="flex gap-1 items-center h-11" aria-haspopup="menu" :aria-expanded="isOpen">
        <span class="text-sm whitespace-nowrap font-medium">{{ $t("Support") }}</span>
        <ChevronDownIcon class="size-3 flex-none transition-transform" :class="isOpen && 'rotate-180'" />
      </button>
    </ContextMenuButtonTrigger>

    <ContextMenuContent class="text-sm">
      <ContextMenuButton @select="openContactForm = true">
        <EnvelopeIcon class="mr-3 h-5 w-5" />
        {{ $t("Contact support") }}
      </ContextMenuButton>
      <ContextMenuButton @select="router.push('/FAQ')">
        <QuestionMarkCircleIcon class="mr-3 h-5 w-5" />
        {{ $t("FAQ") }}
      </ContextMenuButton>
    </ContextMenuContent>
  </ContextMenu>
</template>

<script setup lang="ts">
import { EnvelopeIcon, QuestionMarkCircleIcon } from "@heroicons/vue/24/outline";
import { ChevronDownIcon } from "@heroicons/vue/24/solid";
import ContactForm from "@/components/ContactForm.vue";
import { ref } from "vue";
import { useRouter } from "vue-router";
import {
  ContextMenu,
  ContextMenuButtonTrigger,
  ContextMenuContent,
  ContextMenuButton,
} from "@xs2event/js-lib/components";

const router = useRouter();

const isOpen = ref(false);

const openContactForm = ref(false);

const hideContactForm = () => {
  openContactForm.value = false;
};
</script>
